/**
 * Join two already-formatted range ends into a display string:
 * both set → "from – until", open ends → "<fromPrefix> from" / "<untilPrefix> until".
 * Prefixes are optional; a lone end without its prefix renders bare.
 * Returns empty string when both ends are empty.
 */
export function formatRange({ from, until, fromPrefix, untilPrefix }) {
  if (from && until) return `${from} – ${until}`;
  if (from) return fromPrefix ? `${fromPrefix} ${from}` : from;
  if (until) return untilPrefix ? `${untilPrefix} ${until}` : until;
  return "";
}
